import React, { useState } from "react";
import { Box, Button, CircularProgress, Divider, Popover, Stack, Typography } from "@mui/material";
import { AccountCircle as AccountCircleIcon, Key as KeyIcon } from "@mui/icons-material";
import { obtenerPerfil } from "../services/usuarioService";
import CambiarClave from "./CambiarClave";

const Dato = ({ etiqueta, valor }) => (
    <Box>
        <Typography variant="caption" color="text.secondary">{etiqueta}</Typography>
        <Typography variant="body2">{valor || "—"}</Typography>
    </Box>
);

const PerfilUsuario = ({ usuario }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [perfil, setPerfil] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [dialogoAbierto, setDialogoAbierto] = useState(false);

    const abrir = async (event) => {
        setAnchorEl(event.currentTarget);
        setCargando(true);
        try {
            setPerfil(await obtenerPerfil());
        } catch {
            setPerfil(null);
        } finally {
            setCargando(false);
        }
    };

    const cerrar = () => setAnchorEl(null);

    const abrirCambioDeClave = () => {
        cerrar();
        setDialogoAbierto(true);
    };

    const documento = perfil?.numeroDocumento
        ? `${perfil.tipoDocumento ?? ""} ${perfil.numeroDocumento}`.trim()
        : null;

    return (
        <>
            <Button
                color="inherit"
                onClick={abrir}
                startIcon={<AccountCircleIcon />}
                sx={{ textTransform: "none", mr: 1 }}
                aria-label="Perfil del usuario"
            >
                <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>{usuario}</Box>
            </Button>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={cerrar}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Box sx={{ p: 2, width: 280 }}>
                    {cargando ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                            <CircularProgress size={24} />
                        </Box>
                    ) : (
                        <Stack spacing={1.5}>
                            <Dato etiqueta="Usuario" valor={perfil?.codigo ?? usuario} />
                            {perfil?.idPersona ? (
                                <>
                                    <Dato etiqueta="Nombre" valor={perfil.nombres} />
                                    <Dato etiqueta="Documento" valor={documento} />
                                    <Dato etiqueta="Correo" valor={perfil.email} />
                                    <Dato etiqueta="Celular" valor={perfil.celular} />
                                </>
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    Esta cuenta no está asociada a ninguna persona.
                                </Typography>
                            )}
                        </Stack>
                    )}
                    <Divider sx={{ my: 2 }} />
                    <Button fullWidth variant="outlined" startIcon={<KeyIcon />} onClick={abrirCambioDeClave}>
                        Cambiar clave
                    </Button>
                </Box>
            </Popover>
            <CambiarClave open={dialogoAbierto} onClose={() => setDialogoAbierto(false)} />
        </>
    );
};

export default PerfilUsuario;
